import React from 'react';
import styled from 'styled-components';
import Modal, { Prompt, ModalFooter, ModalHeader } from '@ingka/modal';
import Button from '@ingka/button';
import Text from '@ingka/text';
import { hideError } from '../reducers/error/errorReducer';
import { useStateDispatch, useStateSelector } from '../store';

const StyledText = styled(Text)`
  margin-block-start: 0px;
`;

const ErrorModal = (): JSX.Element | null => {
  const dispatch = useStateDispatch();
  const title = useStateSelector((state) => state.error.title);
  const description = useStateSelector((state) => state.error.description);
  const buttonText = useStateSelector((state) => state.error.button);
  const showError = useStateSelector((state) => state.error.show);

  const clearError = (): void => {
    // Clear error state after modal has finished the closing animation.
    dispatch(hideError());
  };

  const footer = (
    <ModalFooter>
      <Button text={buttonText} type="primary" data-cy="error-modal-button" />
    </ModalFooter>
  );

  const modalContainer: React.JSX.Element = (
    <Modal visible={showError} handleCloseBtn={clearError}>
      <Prompt
        titleId="modalErrorTitleId"
        title={title}
        footer={footer}
        header={<ModalHeader ariaCloseTxt="Close prompt" />}
      >
        <StyledText tagName="p" textStyle="Body.L">
          {description}
        </StyledText>
      </Prompt>
    </Modal>
  );

  return showError ? modalContainer : null;
};

export default ErrorModal;
